import axios from "axios";
import { store } from "../redux/Store";
import Swal from "sweetalert2";
import { logout } from "../redux/user/user.actions";
import Notification from "./notification";

// ALWAYS USE PRODUCTION API - SIMPLE FIX
const URL = "https://api.nhim.ng/api/v1/";

console.log("🚀 API Configuration:");
console.log("Using URL:", URL);

const instance = axios.create({
  baseURL: URL,
  timeout: 15000,
});

instance.interceptors.request.use((config) => {
  console.log("🔄 API Request to:", config.baseURL + config.url);

  if (!config.noload) {
    Swal.fire({
      title: "Please Wait !",
      html: "Loading",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  const { token } = store.getState().user;
  config.headers.Authorization = token ? `Bearer ${token}` : null;
  return config;
});

instance.interceptors.response.use(
  (response) => {
    Swal.close();
    console.log("✅ API Success - Status:", response.status);
    return response;
  },
  (error) => {
    Swal.close();

    console.log("❌ API Error:", {
      message: error.message,
      url: error.config?.baseURL + error.config?.url,
      status: error.response?.status,
    });

    if (error.response?.status === 404) {
      Notification.error("Login failed - Endpoint not found");
    } else if (!error.response) {
      Notification.error("Network error - Cannot connect to server");
    } else {
      Notification.error("Login failed. Please try again.");
    }

    return Promise.reject(error);
  }
);

export default instance;
